import { formatDistanceToNow } from "date-fns";
// src/utils/apiHelpers.js

export const formatTimeAgo = (dateString) => {
  const date = new Date(dateString); // Gawing Date object ang string
  return formatDistanceToNow(date, { addSuffix: true }); // Halimbawa: "1 minute ago"
};


export const formatDate = (dateString) => {
  const date = new Date(dateString); // Gawing Date object ang string
  const options = {
    year: "numeric", // Full year (e.g., 2025)
    month: "long", // Full month name (e.g., January)
    day: "numeric", // Day of the month (e.g., 23)
    hour: "2-digit", // Hour (e.g., 10)
    minute: "2-digit", // Minute (e.g., 10)
    hour12: true, // Gamitin ang 12-hour format (e.g., AM/PM)
  };
    
    // const options = {
    //   year: "numeric",
    //   month: "short", // Short month name (e.g., Jan)
    //   day: "numeric",
    //   hour: "2-digit",
    //   minute: "2-digit",
    //   hour12: true,
    // };
  return date.toLocaleString("en-US", options); // I-convert sa readable format
};